export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  author: string;
  publishedAt: string;
  readTime: number;
  viewCount: number;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
  imageUrl: string;
  imageUrlLarge: string;
}

export const articles: Article[] = [
  {
    id: '1',
    title: '某知名顶流艺人私下合约纠纷曝光，涉及金额超八位数',
    excerpt: '据知情人士透露，该艺人与其经纪公司之间长期存在合约矛盾，近期因分成比例问题矛盾激化，已秘密聘请律师团队准备解约诉讼。',
    content: `<p>据多位接近该艺人的知情人士向爆料网独家透露，近期娱乐圈内一场涉及金额超八位数的合约纠纷正在暗流涌动。</p>
<p>该艺人近三年来凭借多部爆款作品迅速跻身顶流行列，商业价值飙升。然而，其与原经纪公司签订的合约中约定的分成比例仅为行业的40%左右，远低于当前同级别艺人的市场水平。</p>
<p>知情人士称："早在去年年底，该艺人就已经委托律师就合约条款进行审查。原经纪公司在得知此事后，不仅拒绝重新谈判，反而加大了对该艺人行程和商业活动的控制力度，甚至干涉其私人生活。"</p>
<p>据了解，该艺人近期已秘密组建了一支由国内顶级娱乐法律师组成的团队，准备向法院提起解约诉讼。如果诉讼成功，该艺人将面临高达八位数的违约金赔偿，但与其未来商业价值相比，这笔费用被认为是可以接受的。</p>
<p>业内人士分析，此案一旦公开，将对整个娱乐行业的合约模式产生重大影响。近年来，艺人解约纠纷频发，但涉及如此量级的案例并不多见。</p>
<p>截至目前，该艺人及其经纪公司均未对此事做出公开回应。爆料网将持续关注此事的后续发展。</p>`,
    category: 'yule-baoliao',
    author: '爆料网特约记者',
    publishedAt: '2026-08-05',
    readTime: 8,
    viewCount: 128500,
    tags: ['顶流艺人', '合约纠纷', '经纪公司', '解约诉讼', '娱乐圈内幕'],
    isHot: true,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20industry%20drama%20dimly%20lit%20backstage%20scene%20with%20spotlight%20microphone%20stand%20contract%20papers%20on%20table%20cinematic%20moody%20atmosphere%20editorial%20photography%20warm%20dramatic%20lighting%20dark%20background&width=720&height=400&seq=article-card-01&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=Chinese%20entertainment%20industry%20drama%20dimly%20lit%20backstage%20scene%20with%20spotlight%20microphone%20stand%20contract%20papers%20on%20table%20cinematic%20moody%20atmosphere%20editorial%20photography%20warm%20dramatic%20lighting%20dark%20background&width=1400&height=600&seq=article-hero-01&orientation=landscape',
  },
  {
    id: '2',
    title: '某国际快时尚品牌供应链黑幕：血汗工厂实况首次曝光',
    excerpt: '深度调查团队历时三个月，潜入该品牌东南亚供应链体系，揭露其背后令人震惊的劳动条件与环保违规问题。',
    content: `<p>爆料网深度调查团队经过长达三个月的暗访调查，首次揭开了某国际知名快时尚品牌在东南亚地区供应链的黑幕。</p>
<p>调查发现，该品牌在多个东南亚国家的一级供应商工厂中，工人每天工作时长普遍超过12小时，月薪却不足当地最低工资标准的70%。工人们居住在拥挤不堪的集体宿舍中，卫生条件极差。</p>
<p>"我们每天从早上7点工作到晚上10点，中间只有30分钟的午餐时间。如果完不成当日配额，就会被扣工资。"一位不愿透露姓名的工人向调查团队表示。</p>
<p>更令人震惊的是，这些工厂的废水未经处理直接排入当地河流，导致周边村庄的饮用水源受到严重污染。当地居民反映，近年来癌症发病率明显上升。</p>
<p>该品牌近年来在公开场合一直标榜"可持续发展"和"社会责任"，并投入大量资金进行环保形象宣传。然而，调查团队获得的内部文件显示，品牌方对供应商的压价政策才是导致这些恶劣状况的根本原因。</p>
<p>此报道一经发布，已在社交媒体上引发广泛讨论。多位环保组织和劳工权益机构表示将对此展开进一步调查。</p>`,
    category: 'shangye-miwen',
    author: '爆料网调查组',
    publishedAt: '2026-08-04',
    readTime: 12,
    viewCount: 236700,
    tags: ['快时尚', '供应链黑幕', '血汗工厂', '环保违规', '社会责任'],
    isHot: true,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=industrial%20garment%20factory%20interior%20rows%20of%20sewing%20machines%20dim%20lighting%20workers%20silhouettes%20documentary%20style%20gritty%20atmosphere%20dark%20moody%20tones%20social%20realism%20photography&width=720&height=400&seq=article-card-02&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=industrial%20garment%20factory%20interior%20rows%20of%20sewing%20machines%20dim%20lighting%20workers%20silhouettes%20documentary%20style%20gritty%20atmosphere%20dark%20moody%20tones%20social%20realism%20photography&width=1400&height=600&seq=article-hero-02&orientation=landscape',
  },
  {
    id: '3',
    title: '某省厅级干部巨额财产来源不明，纪委已介入调查',
    excerpt: '匿名举报人向爆料网提供大量证据材料，指向某省厅级官员拥有与其合法收入严重不符的巨额财产。',
    content: `<p>日前，爆料网收到一份来自匿名举报人的重磅材料，涉及某省一位厅级领导干部的巨额财产来源不明问题。</p>
<p>根据举报材料显示，该官员及其直系亲属名下拥有多处高端房产，包括省城核心区域的豪宅两套、北京学区房一套、海南度假别墅一栋，总价值超过5000万元。此外，其子女在国外的留学费用和生活开支也远超普通公务员家庭的承受能力。</p>
<p>举报材料中还包含该官员与多名商人之间的资金往来记录，涉及多个房地产开发项目和政府采购项目。材料显示，该官员利用职务之便为特定企业提供便利，其亲属则通过关联公司收取巨额"咨询费"。</p>
<p>爆料网已将相关材料整理后转交省纪委监委。据悉，省纪委已对此事展开初步核查，并约谈了相关当事人。</p>
<p>近年来，反腐倡廉工作持续推进，但仍有少数官员心存侥幸。此案的进展将进一步检验反腐机制的成效。</p>`,
    category: 'shehui-redian',
    author: '爆料网政经组',
    publishedAt: '2026-08-03',
    readTime: 10,
    viewCount: 345200,
    tags: ['反腐', '厅级干部', '巨额财产', '纪委调查', '举报'],
    isHot: true,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=government%20building%20interior%20with%20documents%20spread%20on%20desk%20handcuffs%20and%20cash%20stacks%20serious%20investigative%20mood%20dark%20atmosphere%20anticorruption%20theme%20editorial%20photography&width=720&height=400&seq=article-card-03&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=government%20building%20interior%20with%20documents%20spread%20on%20desk%20handcuffs%20and%20cash%20stacks%20serious%20investigative%20mood%20dark%20atmosphere%20anticorruption%20theme%20editorial%20photography&width=1400&height=600&seq=article-hero-03&orientation=landscape',
  },
  {
    id: '4',
    title: '某人工智能巨头秘密研发下一代大模型，参数规模或将突破万亿',
    excerpt: '多位内部人士透露，该公司的下一代大模型已在秘密训练中，采用了全新的架构设计，推理能力将实现质的飞跃。',
    content: `<p>据多位接近该公司的内部人士向爆料网透露，某国内人工智能巨头正在秘密研发其下一代大语言模型，该项目代号为"启明星"，预计将在今年第四季度公布。</p>
<p>据悉，"启明星"模型将采用全新的混合专家（MoE）架构，参数规模有望突破万亿级别。与传统的大模型不同，"启明星"在训练过程中引入了多模态数据对齐技术，使其在逻辑推理、数学计算和代码生成等方面的能力将远超当前市面上的所有模型。</p>
<p>"这个项目从去年下半年就已经立项了，公司抽调了最核心的研发团队，投入了数以亿计的计算资源。"一位不愿具名的内部人士表示。</p>
<p>值得注意的是，该模型还特别强化了中文语境下的理解能力，在处理中文复杂语义、古文理解和诗词创作等方面有了突破性进展。这在当前全球AI竞争格局下，具有重要的战略意义。</p>
<p>业内分析人士认为，如果该模型如期发布，将彻底改变国内AI产业的竞争格局，同时也将引发新一轮的AI伦理和安全讨论。</p>`,
    category: 'keji-neimu',
    author: '爆料网科技组',
    publishedAt: '2026-08-05',
    readTime: 9,
    viewCount: 89700,
    tags: ['人工智能', '大模型', '万亿参数', '科技内幕', 'AI竞争'],
    isHot: false,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20data%20center%20with%20glowing%20server%20racks%20blue%20and%20amber%20lights%20digital%20brain%20hologram%20floating%20above%20sci%20fi%20atmosphere%20clean%20minimal%20tech%20aesthetic%20cinematic%20lighting&width=720&height=400&seq=article-card-04&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=futuristic%20AI%20data%20center%20with%20glowing%20server%20racks%20blue%20and%20amber%20lights%20digital%20brain%20hologram%20floating%20above%20sci%20fi%20atmosphere%20clean%20minimal%20tech%20aesthetic%20cinematic%20lighting&width=1400&height=600&seq=article-hero-04&orientation=landscape',
  },
  {
    id: '5',
    title: '独家：某国际组织内部文件泄露，全球粮食危机预警升级',
    excerpt: '一份标注为"机密"的内部评估报告显示，全球多个粮食主产区面临减产风险，明年粮食价格可能飙升30%以上。',
    content: `<p>爆料网独家获得一份标注为"机密"级别的国际组织内部评估报告。该报告对2027年全球粮食安全形势做出了极为悲观的预测。</p>
<p>报告指出，受极端天气事件频发、地缘政治冲突持续以及能源价格波动等多重因素影响，全球多个主要粮食产区的产量预计将大幅下降。其中，南亚地区水稻产量可能减少15%-20%，北美玉米带产量预计下降10%左右。</p>
<p>"如果当前趋势持续，2027年全球粮食价格指数可能较当前水平上涨30%至40%，这将是自2008年粮食危机以来最严重的一次。"报告写道。</p>
<p>报告还特别提到了几个脆弱地区：东非的干旱情况正在恶化，也门和南苏丹的粮食安全形势已处于紧急状态。此外，印度近期的大米出口限制政策也对全球大米市场造成了显著冲击。</p>
<p>该报告建议各国政府提前做好粮食储备工作，并呼吁国际社会加强对脆弱地区的粮食援助。爆料网已将相关情况向有关部门进行了通报。</p>`,
    category: 'guoji-baoliao',
    author: '爆料网国际组',
    publishedAt: '2026-08-04',
    readTime: 11,
    viewCount: 156300,
    tags: ['粮食危机', '国际组织', '机密文件', '全球预警', '粮食安全'],
    isHot: true,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=dried%20cracked%20earth%20farmland%20with%20withered%20crops%20golden%20hour%20sunset%20dramatic%20sky%20documentary%20style%20global%20food%20crisis%20theme%20environmental%20photography%20desolate%20atmosphere&width=720&height=400&seq=article-card-05&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=dried%20cracked%20earth%20farmland%20with%20withered%20crops%20golden%20hour%20sunset%20dramatic%20sky%20documentary%20style%20global%20food%20crisis%20theme%20environmental%20photography%20desolate%20atmosphere&width=1400&height=600&seq=article-hero-05&orientation=landscape',
  },
  {
    id: '6',
    title: '知情人士爆料：某大型国企内部贪腐窝案，涉案人员超50人',
    excerpt: '匿名投稿人自称该国企前中层管理人员，提供了详细的贪腐流程和涉案人员名单。',
    content: `<p>近日，一位自称某大型国有企业前中层管理人员的匿名人士向爆料网投稿，揭开了该企业内部一起涉及超过50人的贪腐窝案。</p>
<p>据投稿人描述，该贪腐网络已经运作了至少五年，涉及采购、工程、财务等多个核心部门。主要手段包括：虚增采购价格吃回扣、虚构工程项目套取资金、通过关联公司进行利益输送等。</p>
<p>"我之所以选择站出来，是因为实在看不下去了。这些人的贪婪已经到了无法无天的地步，每年被他们侵吞的国有资产至少上亿元。"投稿人在材料中写道。</p>
<p>材料中还附有大量银行转账记录、内部审批文件和录音证据。这些材料显示，该贪腐网络有着严密的组织架构和分赃机制，从基层采购员到高层管理者，都有明确的分工和利益分配。</p>
<p>值得注意的是，该企业的纪检部门曾多次收到举报，但始终未能有效查处。投稿人怀疑纪检部门内部也存在"保护伞"。</p>
<p>爆料网已对材料进行了初步核实，并将相关证据移交给了上级监管机构。目前，该监管机构已表示将密切关注此事。</p>`,
    category: 'niming-tougao',
    author: '匿名投稿人',
    publishedAt: '2026-08-02',
    readTime: 9,
    viewCount: 289400,
    tags: ['国企贪腐', '窝案', '匿名举报', '国有资产', '内部爆料'],
    isHot: true,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=anonymous%20whistleblower%20silhouette%20in%20dark%20office%20documents%20and%20bank%20statements%20scattered%20on%20desk%20dramatic%20lighting%20mysterious%20atmosphere%20investigative%20journalism%20theme%20noir%20style&width=720&height=400&seq=article-card-06&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=anonymous%20whistleblower%20silhouette%20in%20dark%20office%20documents%20and%20bank%20statements%20scattered%20on%20desk%20dramatic%20lighting%20mysterious%20atmosphere%20investigative%20journalism%20theme%20noir%20style&width=1400&height=600&seq=article-hero-06&orientation=landscape',
  },
  {
    id: '7',
    title: '某综艺节目录制现场发生冲突，三位导师愤然离席',
    excerpt: '据现场观众爆料，冲突起因是节目组为追求收视率恶意剪辑和操纵比赛结果，遭到导师集体抵制。',
    content: `<p>据多位现场观众向爆料网反映，某热门音乐选秀类综艺节目在最新一期录制过程中发生严重冲突，三位导师在录制中途愤然离席，导致录制被迫中断。</p>
<p>据现场观众描述，冲突的导火索是节目组在未与导师沟通的情况下，擅自更改了选手的得分结果，将一位明显表现不佳但"有话题度"的选手强行推进下一轮。</p>
<p>"当时一位导师直接拍了桌子，说'我们辛辛苦苦在这里做音乐，你们就这样玩弄规则？'然后摘下耳麦就走了。另外两位导师也紧随其后离开了录制现场。"一位现场观众回忆道。</p>
<p>该节目自开播以来一直以"真实选秀"为卖点，但近年来频频被质疑存在剧本操作。此次导师集体抗议事件，被认为是长期矛盾积累后的集中爆发。</p>
<p>节目组目前尚未对此事做出正式回应，但据内部人士透露，制作方正在紧急商讨解决方案，希望能说服三位导师回归完成录制。但如果处理不当，该节目可能面临停播风险。</p>`,
    category: 'yule-baoliao',
    author: '爆料网娱乐组',
    publishedAt: '2026-08-03',
    readTime: 7,
    viewCount: 198200,
    tags: ['综艺节目', '录制冲突', '导师离席', '恶意剪辑', '选秀黑幕'],
    isHot: true,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20empty%20judges%20chairs%20spotlights%20dramatic%20stage%20lighting%20red%20and%20amber%20tones%20talent%20show%20atmosphere%20empty%20auditorium%20tense%20mood%20cinematic%20photography&width=720&height=400&seq=article-card-07&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=TV%20studio%20set%20with%20empty%20judges%20chairs%20spotlights%20dramatic%20stage%20lighting%20red%20and%20amber%20tones%20talent%20show%20atmosphere%20empty%20auditorium%20tense%20mood%20cinematic%20photography&width=1400&height=600&seq=article-hero-07&orientation=landscape',
  },
  {
    id: '8',
    title: '深扒某知名电商平台"大数据杀熟"完整操作链',
    excerpt: '技术团队通过对比实验证实，该平台对不同用户群体展示的价格差异最高可达30%，老用户反而更贵。',
    content: `<p>爆料网技术团队经过为期一个月的系统测试，确认某知名电商平台存在严重的"大数据杀熟"行为，并完整还原了其操作链路。</p>
<p>测试团队使用多个不同消费等级、不同注册时长的账号，在同一时间、同一地点搜索相同商品。结果显示，消费频次高、注册时间长的老用户看到的价格普遍比新用户高出15%-30%。</p>
<p>技术分析发现，该平台的定价算法综合考虑了用户的消费历史、设备型号、网络环境甚至搜索关键词的输入速度等多个维度，来判断用户的"价格敏感度"。对价格不敏感的高消费用户，系统会自动推送更高价格的商品。</p>
<p>"最令人气愤的是，即使使用优惠券后，老用户最终支付的价格仍然比新用户高。"测试团队负责人表示。</p>
<p>法律专家指出，这种行为涉嫌违反《消费者权益保护法》和《个人信息保护法》的相关规定。此前，已有多家电商平台因类似行为被监管部门约谈和处罚，但由于技术手段隐蔽，查处难度较大。</p>
<p>截至发稿，该平台尚未对此事作出回应。爆料网建议广大消费者在购物时多加比价，保护自身权益。</p>`,
    category: 'keji-neimu',
    author: '爆料网技术组',
    publishedAt: '2026-08-01',
    readTime: 10,
    viewCount: 176500,
    tags: ['大数据杀熟', '电商平台', '价格歧视', '消费者权益', '算法黑箱'],
    isHot: false,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=smartphone%20showing%20shopping%20app%20with%20different%20price%20tags%20floating%20above%20dark%20background%20data%20visualization%20elements%20algorithmic%20theme%20cyberpunk%20aesthetic%20dark%20amber%20accents%20digital%20illustration&width=720&height=400&seq=article-card-08&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=smartphone%20showing%20shopping%20app%20with%20different%20price%20tags%20floating%20above%20dark%20background%20data%20visualization%20elements%20algorithmic%20theme%20cyberpunk%20aesthetic%20dark%20amber%20accents%20digital%20illustration&width=1400&height=600&seq=article-hero-08&orientation=landscape',
  },
  {
    id: '9',
    title: '某国总统选举背后：境外势力干预证据链被曝光',
    excerpt: '多项证据表明，某大国情报机构通过社交媒体操纵和资金渗透等方式，深度干预了该国的选举进程。',
    content: `<p>爆料网国际调查组联合多家国际媒体，获取了某大国情报机构干预邻国总统选举的大量证据。这些证据构成了一条完整的干预链条，揭示了现代信息战在国家政治中的深度渗透。</p>
<p>调查显示，该情报机构通过设立数百个虚假社交媒体账号和网站，系统性地散布针对特定候选人的虚假信息和丑闻。这些内容通过精心设计的信息传播网络，在选举前三个月内覆盖了该国超过60%的社交媒体用户。</p>
<p>此外，资金追踪记录显示，至少有2000万美元的"黑金"通过离岸公司和空壳机构流入该国，用于资助亲特定势力的政治团体和媒体机构。</p>
<p>"这已经不是传统意义上的选举干预，而是一场全方位的信息战。"一位国际政治分析人士评论道。</p>
<p>该被干预国家的外交部已发表声明，强烈谴责这种干涉内政的行为，并表示将向联合国提交正式抗议。而涉事大国的官方则否认了所有指控，称这些指控是"毫无根据的政治抹黑"。</p>`,
    category: 'guoji-baoliao',
    author: '爆料网国际调查组',
    publishedAt: '2026-07-30',
    readTime: 13,
    viewCount: 213600,
    tags: ['选举干预', '境外势力', '信息战', '国际政治', '黑金政治'],
    isHot: false,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=world%20map%20with%20digital%20connections%20and%20shadow%20figures%20manipulating%20strings%20political%20interference%20theme%20dark%20geopolitical%20atmosphere%20red%20and%20dark%20tones%20cinematic%20thriller%20style%20dramatic%20lighting&width=720&height=400&seq=article-card-09&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=world%20map%20with%20digital%20connections%20and%20shadow%20figures%20manipulating%20strings%20political%20interference%20theme%20dark%20geopolitical%20atmosphere%20red%20and%20dark%20tones%20cinematic%20thriller%20style%20dramatic%20lighting&width=1400&height=600&seq=article-hero-09&orientation=landscape',
  },
  {
    id: '10',
    title: '知名连锁餐饮品牌后厨乱象触目惊心，过期食材照常使用',
    excerpt: '匿名员工投稿曝光某知名连锁餐饮品牌的后厨真实情况，食品卫生安全状况令人担忧。',
    content: `<p>一位自称在某知名连锁餐饮品牌工作了两年多的匿名员工向爆料网投稿，揭露了该品牌后厨的种种乱象。</p>
<p>根据投稿人描述，该品牌门店普遍存在以下问题：过期食材更改日期标签后继续使用、油炸用油超过安全使用天数后仍不更换、员工徒手处理食材不佩戴手套、厨房蟑螂鼠患严重但从未进行专业消杀。</p>
<p>"最让我无法接受的是，有一次一批鸡肉明显已经变质发臭，但店长还是让厨师加大量调味料掩盖味道后做成菜品卖给顾客。"投稿人在材料中写道。</p>
<p>投稿人还提供了多段后厨偷拍视频和多张照片作为证据，画面中确实可以看到令人不适的卫生状况。这些证据已经过爆料网的技术鉴定，确认为真实拍摄。</p>
<p>该品牌在全国拥有超过500家门店，年营收超过50亿元，以"新鲜、健康、美味"为品牌口号。如果这些爆料属实，将对该品牌造成毁灭性打击。</p>
<p>爆料网已向当地市场监管部门反映了相关情况。食品安全无小事，我们呼吁监管部门加大对此类违法行为的查处力度。</p>`,
    category: 'niming-tougao',
    author: '匿名投稿人',
    publishedAt: '2026-08-05',
    readTime: 8,
    viewCount: 167800,
    tags: ['食品安全', '餐饮黑幕', '后厨乱象', '过期食材', '匿名举报'],
    isHot: true,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=dirty%20restaurant%20kitchen%20with%20grimy%20surfaces%20expired%20food%20containers%20dim%20fluorescent%20lighting%20documentary%20style%20investigative%20photography%20unpleasant%20atmosphere%20dark%20realistic%20tones&width=720&height=400&seq=article-card-10&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=dirty%20restaurant%20kitchen%20with%20grimy%20surfaces%20expired%20food%20containers%20dim%20fluorescent%20lighting%20documentary%20style%20investigative%20photography%20unpleasant%20atmosphere%20dark%20realistic%20tones&width=1400&height=600&seq=article-hero-10&orientation=landscape',
  },
  {
    id: '11',
    title: '某知名女星疑似与富商密会，婚姻状况再引猜测',
    excerpt: '狗仔队拍到该女星深夜出入某顶级私人会所，与神秘男子独处数小时，引发外界对其婚姻状况的广泛讨论。',
    content: `<p>近日，某知名女星被拍到深夜独自驾车前往位于市中心的一家顶级私人会所，与一位身份神秘的男子独处长达四个小时后才离开。这一消息迅速在社交媒体上引发热议。</p>
<p>据拍摄到的画面显示，该女星当晚身穿低调的黑色休闲装，头戴棒球帽和口罩，显然是刻意避开公众视线。而与其会面的男子则被认出是某知名企业的年轻掌门人，身家数十亿。</p>
<p>值得注意的是，该女星此前曾在多个公开场合表示婚姻幸福，与丈夫感情稳定。但近半年来，两人在社交媒体上的互动明显减少，且多次被拍到分别出行，引发外界对其婚姻状况的猜测。</p>
<p>截至目前，该女星及其工作室均未对此事做出回应。其丈夫的社交媒体账号也处于静默状态。</p>
<p>娱乐圈的感情纠葛向来是吃瓜群众最热衷的话题。此次事件究竟是单纯的商务会面还是另有隐情，恐怕只有当事人自己最清楚。爆料网将保持关注。</p>`,
    category: 'yule-baoliao',
    author: '爆料网娱乐组',
    publishedAt: '2026-08-04',
    readTime: 6,
    viewCount: 412300,
    tags: ['女星密会', '富商', '婚姻猜测', '娱乐圈八卦', '狗仔爆料'],
    isHot: true,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=paparazzi%20night%20photography%20luxury%20car%20outside%20exclusive%20club%20entrance%20city%20lights%20bokeh%20effect%20mysterious%20atmosphere%20celebrity%20gossip%20theme%20noir%20style%20warm%20street%20lamps%20dark%20night&width=720&height=400&seq=article-card-11&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=paparazzi%20night%20photography%20luxury%20car%20outside%20exclusive%20club%20entrance%20city%20lights%20bokeh%20effect%20mysterious%20atmosphere%20celebrity%20gossip%20theme%20noir%20style%20warm%20street%20lamps%20dark%20night&width=1400&height=600&seq=article-hero-11&orientation=landscape',
  },
  {
    id: '12',
    title: '某地大型房地产项目烂尾背后：地方政府与开发商的利益输送链',
    excerpt: '项目停工两年，数千户业主无家可归。深挖发现，该项目从拿地到预售的每个环节都存在问题。',
    content: `<p>位于某二线城市核心区域的大型住宅项目，自2024年停工以来已整整两年。数千户已支付购房款的业主至今无家可归，每月还要偿还银行贷款。爆料网对该项目进行了深入调查，发现其烂尾背后隐藏着复杂的利益输送链条。</p>
<p>调查发现，该项目的土地使用权出让过程中存在明显的违规操作。在招拍挂之前，地块的规划条件已经被"量身定制"，使得某家实力并不匹配的开发商能够以低于市场价30%的价格拿地。</p>
<p>更令人震惊的是，该项目在仅完成地基施工的情况下，就获得了商品房预售许可证。按照规定，多层建筑需要完成主体结构封顶后方可预售。但当地住建部门却对此"开了绿灯"。</p>
<p>"这绝不是个别工作人员的渎职行为，而是一个系统性的腐败链条。"一位不愿具名的业内人士表示。据其透露，涉及此案的包括多个政府部门的负责人和开发商的实控人。</p>
<p>目前，部分业主已联合起来通过法律途径维权，但进展缓慢。爆料网将持续关注此事，也呼吁有关部门尽快介入解决，让数千户家庭早日有一个安身之所。</p>`,
    category: 'shehui-redian',
    author: '爆料网社会组',
    publishedAt: '2026-07-28',
    readTime: 11,
    viewCount: 267100,
    tags: ['房地产烂尾', '利益输送', '业主维权', '预售违规', '地方腐败'],
    isHot: true,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=abandoned%20construction%20site%20with%20unfinished%20concrete%20building%20frames%20overcast%20sky%20scattered%20construction%20materials%20desolate%20urban%20scene%20documentary%20photography%20gloomy%20atmosphere%20social%20commentary&width=720&height=400&seq=article-card-12&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=abandoned%20construction%20site%20with%20unfinished%20concrete%20building%20frames%20overcast%20sky%20scattered%20construction%20materials%20desolate%20urban%20scene%20documentary%20photography%20gloomy%20atmosphere%20social%20commentary&width=1400&height=600&seq=article-hero-12&orientation=landscape',
  },
  {
    id: '13',
    title: '某新能源汽车巨头电池技术被指夸大宣传，实际续航缩水40%',
    excerpt: '独立测试机构的数据显示，该品牌多款车型的实际续航里程与官方宣传存在巨大差距。',
    content: `<p>某独立汽车测试机构近日发布了一份针对主流新能源汽车的续航测试报告，结果显示，某头部新能源汽车品牌的多款车型实际续航里程与官方宣传存在40%左右的巨大差距。</p>
<p>测试在标准条件下进行，包括城市道路、高速公路和山区道路等综合路况。测试车辆均为从市场上随机购买的商品车，而非厂家提供的特调车辆。</p>
<p>以该品牌旗下最畅销的SUV车型为例，官方宣称的CLTC续航里程为700公里，但在实际测试中，综合路况下仅能行驶约420公里，缩水幅度高达40%。即便在理想的城市通勤工况下，实测续航也只有530公里左右。</p>
<p>"消费者买车时看到的是700公里的续航，结果实际使用只有四百多公里。这种差距已经超出了正常误差范围，涉嫌虚假宣传。"测试机构负责人表示。</p>
<p>该品牌此前在多个广告中均以"超长续航"作为核心卖点，并投入巨额营销费用打造"续航之王"的形象。如果上述测试结果属实，该品牌将面临大量消费者的索赔诉讼。</p>
<p>截至目前，该品牌尚未对测试报告做出回应。爆料网建议消费者在购车时多看第三方实测数据，不要轻信官方宣传。</p>`,
    category: 'shangye-miwen',
    author: '爆料网汽车组',
    publishedAt: '2026-08-02',
    readTime: 9,
    viewCount: 189400,
    tags: ['新能源汽车', '续航虚标', '夸大宣传', '消费者维权', '独立测试'],
    isHot: false,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20electric%20car%20on%20test%20track%20with%20digital%20dashboard%20showing%20low%20battery%20warning%20futuristic%20automotive%20photography%20clean%20minimal%20design%20overcast%20sky%20product%20review%20style&width=720&height=400&seq=article-card-13&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=modern%20electric%20car%20on%20test%20track%20with%20digital%20dashboard%20showing%20low%20battery%20warning%20futuristic%20automotive%20photography%20clean%20minimal%20design%20overcast%20sky%20product%20review%20style&width=1400&height=600&seq=article-hero-13&orientation=landscape',
  },
  {
    id: '14',
    title: '暗访调查：网络水军产业链全揭秘，一条评论五毛钱',
    excerpt: '记者卧底多个网络水军群组，揭开了从接单到执行的全链条运作模式和惊人的产业规模。',
    content: `<p>在社交媒体时代，你看到的"热门评论"和"网友观点"，可能只是网络水军的批量产品。爆料网记者历时两个月潜入多个网络水军群组，完整还原了一条从接单到执行的灰色产业链。</p>
<p>调查发现，网络水军产业已经形成了高度组织化的运作模式。产业链的上游是"公关公司"或"营销机构"，他们承接企业客户的订单，然后将任务层层分包给下游的"水军头目"，最终由成千上万的"水军"个体执行。</p>
<p>记者在卧底期间发现，一条普通的微博评论报价为0.5元，一篇带图的高质量"种草"帖子则可以卖到50-200元。水军头目通过即时通讯工具下发任务，水军们按照模板完成任务后截图提交，即可获得报酬。</p>
<p>"我们有一个五千人的大群，里面都是全职或兼职的。任务从来不断，有时候一天能接到上百单。"一位水军头目向记者透露。</p>
<p>据估算，中国网络水军产业的年产值可能高达数百亿元。这些水军不仅操纵舆论、制造虚假热度，还会对竞争对手进行恶意抹黑，严重破坏了网络生态。</p>
<p>法律专家指出，网络水军的行为涉嫌违反《反不正当竞争法》和《网络安全法》等多项法律法规，但因取证困难，查处力度一直不够。</p>`,
    category: 'keji-neimu',
    author: '爆料网调查组',
    publishedAt: '2026-07-25',
    readTime: 10,
    viewCount: 143200,
    tags: ['网络水军', '灰色产业链', '舆论操纵', '卧底调查', '五毛党'],
    isHot: false,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=dark%20room%20with%20multiple%20computer%20screens%20displaying%20social%20media%20feeds%20anonymous%20figure%20typing%20on%20keyboard%20cyberpunk%20noir%20style%20underground%20internet%20operation%20dark%20red%20accents%20suspenseful%20atmosphere&width=720&height=400&seq=article-card-14&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=dark%20room%20with%20multiple%20computer%20screens%20displaying%20social%20media%20feeds%20anonymous%20figure%20typing%20on%20keyboard%20cyberpunk%20noir%20style%20underground%20internet%20operation%20dark%20red%20accents%20suspenseful%20atmosphere&width=1400&height=600&seq=article-hero-14&orientation=landscape',
  },
  {
    id: '15',
    title: '某国际药企疫苗副作用数据被曝刻意隐瞒，内部邮件曝光',
    excerpt: '该公司内部邮件显示，高层明知某疫苗存在严重副作用，却选择向监管机构和公众隐瞒相关数据。',
    content: `<p>爆料网国际组获得了一组某国际制药巨头的内部邮件，这些邮件显示，该公司在2023年至2025年期间，系统性地隐瞒了其某款畅销疫苗的严重副作用数据。</p>
<p>邮件内容显示，该公司的安全监测团队早在2023年就发现了这款疫苗与一种罕见但严重的心血管疾病之间存在统计学上的显著关联。然而，当安全团队将这一发现上报后，公司高管明确指示"控制信息披露范围"，并推迟了向监管机构的报告。</p>
<p>"如果我们现在公开这些数据，不仅这款产品的销售额会归零，整个公司的声誉也将遭受毁灭性打击。"一封标注为"机密-仅限内部"的邮件中写道。</p>
<p>在隐瞒副作用的期间，该疫苗继续在全球范围内销售，年销售额超过50亿美元。据独立研究机构估计，可能已有数千人在接种后出现了未被报告的严重不良反应。</p>
<p>该制药公司的发言人随后发表声明，否认了所有指控，称这些邮件是"断章取义"和"恶意编造"。但多位法律专家表示，如果这些邮件的真实性得到证实，该公司将面临天价赔偿和刑事责任。</p>
<p>爆料网已将相关材料提交给了国际药品监管机构，并将密切关注此事的后续发展。</p>`,
    category: 'guoji-baoliao',
    author: '爆料网国际组',
    publishedAt: '2026-07-26',
    readTime: 11,
    viewCount: 321800,
    tags: ['药企丑闻', '疫苗副作用', '数据隐瞒', '内部邮件', '药品安全'],
    isHot: true,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=pharmaceutical%20laboratory%20with%20test%20tubes%20and%20medical%20documents%20stamped%20confidential%20dark%20corporate%20atmosphere%20whistleblower%20theme%20blue%20and%20white%20sterile%20lighting%20investigative%20journalism%20style&width=720&height=400&seq=article-card-15&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=pharmaceutical%20laboratory%20with%20test%20tubes%20and%20medical%20documents%20stamped%20confidential%20dark%20corporate%20atmosphere%20whistleblower%20theme%20blue%20and%20white%20sterile%20lighting%20investigative%20journalism%20style&width=1400&height=600&seq=article-hero-15&orientation=landscape',
  },
  {
    id: '16',
    title: '某知名歌手被曝抄袭国外小众音乐人作品，多首金曲高度雷同',
    excerpt: '热心网友通过音频比对发现，该歌手的多首热门单曲与国外小众音乐人的早期作品惊人相似。',
    content: `<p>近日，一段由热心网友制作的音频比对视频在社交媒体上疯传，将某知名华语歌手的多首热门单曲与多位国外小众音乐人的早期作品进行了逐段对比，结果令人震惊。</p>
<p>对比视频显示，该歌手的成名曲《XX》的副歌旋律与一位北欧小众音乐人在2015年发布的歌曲存在惊人的相似度，几乎达到了逐音对应的程度。此外，其另外两首传唱度极高的金曲也分别与另两位国外音乐人的作品高度雷同。</p>
<p>音乐专业人士对视频进行了分析后表示："从音乐理论的角度来看，这些相似已经超出了'巧合'或'灵感借鉴'的范畴。旋律走向、和声进行、节奏编排的相似度非常高。"</p>
<p>该事件发酵后，已有被抄袭的音乐人通过社交媒体表达了关注。其中一位表示正在咨询律师，考虑采取法律行动。</p>
<p>该歌手的工作室随后发布声明，否认了抄袭指控，称"所有的创作都是原创的，所谓的相似只是音乐创作中的正常现象"。但这一回应并未平息争议，反而引发了更多网友的扒谱对比。</p>
<p>近年来，华语乐坛抄袭风波不断。此事件再次引发了关于音乐版权保护和原创精神的广泛讨论。</p>`,
    category: 'yule-baoliao',
    author: '爆料网娱乐组',
    publishedAt: '2026-07-29',
    readTime: 8,
    viewCount: 276900,
    tags: ['歌手抄袭', '音乐版权', '音频比对', '原创争议', '华语乐坛'],
    isHot: true,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=music%20studio%20with%20sheet%20music%20and%20audio%20waveforms%20on%20computer%20screen%20side%20by%20side%20comparison%20dramatic%20lighting%20copyright%20dispute%20theme%20warm%20studio%20atmosphere%20editorial%20style&width=720&height=400&seq=article-card-16&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=music%20studio%20with%20sheet%20music%20and%20audio%20waveforms%20on%20computer%20screen%20side%20by%20side%20comparison%20dramatic%20lighting%20copyright%20dispute%20theme%20warm%20studio%20atmosphere%20editorial%20style&width=1400&height=600&seq=article-hero-16&orientation=landscape',
  },
  {
    id: '17',
    title: '匿名举报：某三甲医院科室主任长期收受药企回扣',
    excerpt: '举报材料包含详细的回扣金额、时间记录和银行转账凭证，涉事金额高达数百万元。',
    content: `<p>一位自称某三甲医院在职医生的匿名人士向爆料网提交了详细的举报材料，指控该院某重点科室主任长期收受多家药企的巨额回扣。</p>
<p>举报材料显示，该科室主任自2019年以来，利用其在新药采购和设备引进方面的决策权，先后收受了至少六家药企和医疗器械公司的回扣。回扣形式多样，包括直接现金、通过亲属账户转账、赠送名贵礼品和安排海外考察等。</p>
<p>材料中附有一份详细的"回扣账本"，记录了2019年至2025年间每一笔回扣的时间、金额和来源。总金额初步估算超过500万元。其中，金额最大的一笔是某跨国药企为推广其新获批的肿瘤药物支付的180万元。</p>
<p>"作为一名在一线工作的医生，看到这种情况真的非常痛心。这些回扣最终都会转嫁到患者身上，让本已高昂的医疗费用雪上加霜。"投稿人在材料中写道。</p>
<p>爆料网已对举报材料的真实性进行了初步核实，银行流水记录中的关键信息与公开可查的工商信息吻合。目前，相关材料已提交给卫生健康主管部门和纪检监察机关。</p>`,
    category: 'niming-tougao',
    author: '匿名投稿人',
    publishedAt: '2026-07-27',
    readTime: 9,
    viewCount: 356700,
    tags: ['医疗腐败', '药企回扣', '三甲医院', '匿名举报', '医药反腐'],
    isHot: true,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=hospital%20corridor%20with%20shadow%20figure%20handing%20envelope%20to%20doctor%20in%20white%20coat%20dim%20clinical%20lighting%20medical%20corruption%20theme%20suspenseful%20atmosphere%20noir%20documentary%20style&width=720&height=400&seq=article-card-17&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=hospital%20corridor%20with%20shadow%20figure%20handing%20envelope%20to%20doctor%20in%20white%20coat%20dim%20clinical%20lighting%20medical%20corruption%20theme%20suspenseful%20atmosphere%20noir%20documentary%20style&width=1400&height=600&seq=article-hero-17&orientation=landscape',
  },
  {
    id: '18',
    title: '某知名投资机构合伙人内部斗争白热化，多名核心成员或将出走',
    excerpt: '知情人透露，该机构因投资策略分歧和利益分配不均导致内部矛盾激化，已有多位合伙人私下接触猎头。',
    content: `<p>据多位知情人士向爆料网透露，国内某顶级投资机构近来内部矛盾激化，合伙人之间的斗争已经进入白热化阶段，多名核心成员正在考虑出走。</p>
<p>据了解，矛盾的根源在于投资策略的根本分歧。以创始合伙人为首的一派主张继续深耕传统的互联网和消费赛道，而以几位年轻合伙人为代表的另一派则认为应该全面转向人工智能和新能源等硬科技领域。</p>
<p>"过去两年，坚持投硬科技的几位合伙人的项目回报率明显更高，但创始合伙人依然把持着投资决策委员会的多数席位，导致大量优质硬科技项目被否决。"一位接近该机构的人士表示。</p>
<p>除了策略分歧，利益分配也是一个核心矛盾点。该机构的利润分配机制已经多年未调整，年轻一代的合伙人认为自己的贡献与回报严重不匹配。</p>
<p>据悉，已有至少三位管理合伙人正在通过猎头接触其他机构，其中一人已经收到了某国际顶级基金的offer。如果核心团队大规模出走，不仅会影响该机构的品牌和募资能力，已投项目的后续管理也将面临挑战。</p>`,
    category: 'shangye-miwen',
    author: '爆料网财经组',
    publishedAt: '2026-08-01',
    readTime: 8,
    viewCount: 98700,
    tags: ['投资机构', '内部斗争', '合伙人出走', '利益分配', '金融内幕'],
    isHot: false,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20boardroom%20with%20empty%20chairs%20around%20long%20table%20tension%20atmosphere%20scattered%20documents%20dramatic%20corporate%20lighting%20financial%20district%20view%20through%20windows%20power%20struggle%20theme%20cinematic%20style&width=720&height=400&seq=article-card-18&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=modern%20boardroom%20with%20empty%20chairs%20around%20long%20table%20tension%20atmosphere%20scattered%20documents%20dramatic%20corporate%20lighting%20financial%20district%20view%20through%20windows%20power%20struggle%20theme%20cinematic%20style&width=1400&height=600&seq=article-hero-18&orientation=landscape',
  },
  {
    id: '19',
    title: '某省会城市地铁工程质量问题曝光，通车三年即出现严重沉降',
    excerpt: '内部工程报告显示，该地铁线路多个区间段已出现不均匀沉降，最大沉降量超过安全标准的三倍。',
    content: `<p>爆料网获得一份某省会城市地铁3号线的内部工程监测报告，该报告显示，这条通车仅三年的地铁线路已出现严重的工程质量问题。</p>
<p>报告数据显示，该线路多个区间段出现了不同程度的不均匀沉降。其中，穿越老城区的一段隧道最大沉降量达到了惊人的25厘米，是国家标准允许范围的3倍以上。部分车站的地面也出现了明显的裂缝和变形。</p>
<p>"如果沉降趋势得不到有效控制，未来可能出现隧道结构损坏甚至坍塌的风险。"一位参与该线路设计的工程师匿名向爆料网表示。据其透露，沉降问题的根源在于施工时偷工减料，盾构掘进过程中未按设计要求进行充分的注浆加固。</p>
<p>更令人担忧的是，该问题早在建设期间就已经被工程监理单位发现并提出，但施工方和业主单位为了赶工期和节约成本，选择性地忽视了这些警告。</p>
<p>目前，该地铁公司尚未对公众披露相关风险。每天仍有数十万乘客在这条存在安全隐患的地铁线路上通行。爆料网呼吁有关部门立即介入，进行全面安全评估，确保市民的出行安全。</p>`,
    category: 'shehui-redian',
    author: '爆料网社会组',
    publishedAt: '2026-07-24',
    readTime: 9,
    viewCount: 234500,
    tags: ['地铁工程', '质量问题', '沉降超标', '偷工减料', '公共安全'],
    isHot: false,
    isExclusive: true,
    imageUrl: 'https://readdy.ai/api/search-image?query=underground%20subway%20tunnel%20with%20visible%20cracks%20in%20concrete%20walls%20dim%20emergency%20lighting%20industrial%20infrastructure%20scene%20construction%20quality%20theme%20gritty%20documentary%20photography%20engineering%20failure&width=720&height=400&seq=article-card-19&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=underground%20subway%20tunnel%20with%20visible%20cracks%20in%20concrete%20walls%20dim%20emergency%20lighting%20industrial%20infrastructure%20scene%20construction%20quality%20theme%20gritty%20documentary%20photography%20engineering%20failure&width=1400&height=600&seq=article-hero-19&orientation=landscape',
  },
  {
    id: '20',
    title: '某国际组织前官员出书爆料：全球气候谈判背后的利益博弈',
    excerpt: '该前官员在回忆录中详述了各国在气候谈判中的暗中交易和利益交换，揭露了看似崇高的环保目标背后的残酷现实。',
    content: `<p>一位曾在某重要国际气候组织担任高级职务长达十五年的前官员，近日出版了一本爆炸性的回忆录，首次公开了全球气候谈判幕后的种种利益博弈和暗中交易。</p>
<p>书中披露，一些表面上积极推动减排的发达国家，实际上在谈判中通过各种方式维护本国化石燃料行业的利益。例如，某欧洲大国在公开场合承诺大幅减排，却在谈判文本中巧妙地设置了大量"技术性条款"，使得其国内的航空和航运业可以规避减排义务。</p>
<p>作者还详述了发展中国家与发达国家之间围绕"气候资金"的激烈博弈。发达国家承诺每年提供1000亿美元气候援助，但实际到位的资金不到承诺的一半，且其中大量是以商业贷款而非赠款的形式提供，实际上加重了贫困国家的债务负担。</p>
<p>"气候谈判本质上不是关于拯救地球，而是关于利益分配。每个国家都在计算自己的得失，真正关心地球未来的少之又少。"作者在书中写道。</p>
<p>该书出版后在国际社会引起了强烈反响。多个环保组织表示书中的内容印证了他们长期的观察，但也有相关国家的外交部门对书中的描述予以否认。</p>`,
    category: 'guoji-baoliao',
    author: '爆料网国际组',
    publishedAt: '2026-07-22',
    readTime: 12,
    viewCount: 112300,
    tags: ['气候谈判', '利益博弈', '回忆录爆料', '国际政治', '环保内幕'],
    isHot: false,
    isExclusive: false,
    imageUrl: 'https://readdy.ai/api/search-image?query=international%20conference%20hall%20with%20world%20flags%20empty%20negotiating%20table%20dramatic%20lighting%20geopolitical%20theme%20dark%20suits%20and%20documents%20suspenseful%20atmosphere%20cinematic%20diplomatic%20photography&width=720&height=400&seq=article-card-20&orientation=landscape',
    imageUrlLarge: 'https://readdy.ai/api/search-image?query=international%20conference%20hall%20with%20world%20flags%20empty%20negotiating%20table%20dramatic%20lighting%20geopolitical%20theme%20dark%20suits%20and%20documents%20suspenseful%20atmosphere%20cinematic%20diplomatic%20photography&width=1400&height=600&seq=article-hero-20&orientation=landscape',
  },
];

export const getArticleById = (id: string): Article | undefined =>
  articles.find((a) => a.id === id);

export const getArticlesByCategory = (slug: string): Article[] =>
  articles.filter((a) => a.category === slug);

export const getHotArticles = (): Article[] =>
  articles.filter((a) => a.isHot).sort((a, b) => b.viewCount - a.viewCount);

export const getLatestArticles = (limit?: number): Article[] =>
  [...articles].sort((a, b) => new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()).slice(0, limit);

export const getRelatedArticles = (article: Article, limit: number = 4): Article[] =>
  articles
    .filter((a) => a.id !== article.id && a.category === article.category)
    .sort((a, b) => b.viewCount - a.viewCount)
    .slice(0, limit);